import React from 'react';
import { Form, Button, Table } from 'react-bootstrap';

export function Privacy() {
  return (
    <div style={{ flexGrow: 1 }}>
      <h2 style={{ fontSize: '1.75rem', marginBottom: '1rem' }}>Profile Visibility Settings</h2>

      <p style={{ color: '#6c757d', marginBottom: '1rem' }}>
        Select who may see your profile details.
      </p>

      <div style={{ marginBottom: '1rem' }}>
        <Table borderless style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ fontWeight: 600, padding: '1rem 0.75rem', borderBottom: '1px solid #dee2e6', width: '50%' }}>
                Details
              </th>
              <th style={{ fontWeight: 600, padding: '1rem 0.75rem', borderBottom: '1px solid #dee2e6' }}>
                Visibility
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: '1rem 0.75rem', backgroundColor: '#f8f9fa', verticalAlign: 'middle' }}>
                First Name
              </td>
              <td style={{ padding: '1rem 0.75rem', backgroundColor: '#f8f9fa' }}>
                <div style={{ color: '#6c757d' }}>Public</div>
              </td>
            </tr>
            <tr>
              <td style={{ padding: '1rem 0.75rem', backgroundColor: '#f8f9fa', verticalAlign: 'middle', borderBottom: '8px solid white' }}>
                Last Name
              </td>
              <td style={{ padding: '1rem 0.75rem', backgroundColor: '#f8f9fa', borderBottom: '8px solid white' }}>
                <Form.Select
                  style={{
                    borderRadius: '0.375rem',
                    padding: '0.75rem 2.25rem 0.75rem 0.75rem',
                    fontSize: '1rem',
                    backgroundColor: 'white',
                    borderColor: '#ced4da',
                  }}
                >
                  <option>Public</option>
                  <option>All Members</option>
                  <option>My Connections</option>
                  <option>Only Me</option>
                </Form.Select>
              </td>
            </tr>
            <tr>
              <td style={{ padding: '1rem 0.75rem', backgroundColor: '#f8f9fa', verticalAlign: 'middle', borderBottom: '8px solid white' }}>
                Nickname
              </td>
              <td style={{ padding: '1rem 0.75rem', backgroundColor: '#f8f9fa', borderBottom: '8px solid white' }}>
                <Form.Select
                  style={{
                    borderRadius: '0.375rem',
                    padding: '0.75rem 2.25rem 0.75rem 0.75rem',
                    fontSize: '1rem',
                    backgroundColor: 'white',
                    borderColor: '#ced4da',
                  }}
                >
                  <option>Public</option>
                  <option>All Members</option>
                  <option>My Connections</option>
                  <option>Only Me</option>
                </Form.Select>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      <Button
        style={{
          backgroundColor: '#0d6efd',
          borderColor: '#0d6efd',
          paddingLeft: '2rem',
          paddingRight: '2rem',
          fontSize: '1.25rem',
          borderRadius: '0.375rem',
        }}
      >
        Save Changes
      </Button>
    </div>
  );
}
